var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.266,
    height: 29.285,
    viewBox: "0 0 29.266 29.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "refresh-icon",
    d: "M30.98,10.3a14.645,14.645,0,1,0,3.807,14H30.98A10.977,10.977,0,1,1,20.639,9.661a10.826,10.826,0,0,1,7.724,3.258l-5.894,5.894H35.281V6Z",
    transform: "translate(-6.015 -6)",
    fill: "#fbf8fd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.5baf262c37adda5d38df111f2e0108c9.svg";
export { ForwardRef as ReactComponent };